<template>
  <b-card title="Power supply" body-class="power-supply-card">
    <table class="table">
      <tr>
        <td>
          <strong>Mains</strong>
        </td>
        <td v-bind:class="power_mains_status_class" class="text-right">
          <span id="power-mains-status-circle">&#11044;</span>
          <b-tooltip
            :target="'power-mains-status-circle'"
            :container="'power-mains-status-circle'"
            :title="power_mains_status_title_text"
          />
        </td>
      </tr>
      <tr>
        <td>
          <strong>Battery</strong>
        </td>
        <td v-bind:class="power_battery_status_class" class="text-right">
          <span id="power-battery-status-circle">&#11044;</span>
          <b-tooltip
            :target="'power-battery-status-circle'"
            :container="'power-battery-status-circle'"
            :title="power_battery_status_title_text"
          />
        </td>
      </tr>
    </table>
    <CardTimestampFooter v-bind:timestamp="timestamp" />
  </b-card>
</template>
<script>
import CardTimestampFooter from "@/components/Device/CardTimestampFooter/CardTimestampFooter";

export default {
  name: "PowerSupplyCard",
  components: { CardTimestampFooter },
  props: ["power_supply"],
  computed: {
    battery_state() {
      return this._props.power_supply && this._props.power_supply.battery_state
        ? this._props.power_supply.battery_state
        : "UNKNOWN";
    },
    mains_state() {
      return this._props.power_supply && this._props.power_supply.mains_state
        ? this._props.power_supply.mains_state
        : "UNKNOWN";
    },
    power_mains_status_class() {
      return this.power_status_class(this.mains_state);
    },
    power_battery_status_class() {
      return this.power_status_class(this.battery_state);
    },
    power_mains_status_title_text() {
      switch (this.mains_state) {
        case "OK":
          return "Mains supply is present";
        case "UNKNOWN":
          return "Mains supply is in unknown state";
        case "NO_VOLTAGE":
          return "Mains supply is not present";
        default:
          return 'Mains supply is in "' + this.mains_state + '" state';
      }
    },
    power_battery_status_title_text() {
      switch (this.battery_state) {
        case "OK":
          return "Battery is OK";
        case "UNKNOWN":
          return "Battery is in unknown state";
        case "LOW_LEVEL":
          return "Battery level is low";
        default:
          return 'Battery level is in "' + this.battery_state + '" state';
      }
    },
    timestamp() {
      return this._props.power_supply && this._props.power_supply.timestamp
        ? this._props.power_supply.timestamp
        : null;
    }
  },
  methods: {
    power_status_class(value) {
      return {
        "text-success": value === "OK",
        "text-secondary": value === "UNKNOWN" || !value,
        "text-danger": value !== "OK" && value !== "UNKNOWN" && value !== ""
      };
    }
  }
};
</script>

<style src="./PowerSupplyCard.scss" lang="scss" scoped/>
